import api from './api';

/**
 * Service for PRD generation operations
 */
const prdService = {
  /**
   * Generate a customer-facing PRD for validation/sign-off
   * @param {string} projectId - The project ID
   * @returns {Promise<Object>} The generated PRD document
   */
  generateCustomerPRD: async (projectId) => {
    try {
      console.log(`Generating customer-facing PRD for project ${projectId}`);
      const response = await api.post(`/api/prd/projects/${projectId}/customer-prd`);
      return response.data.data;
    } catch (error) {
      console.error('Error generating customer PRD:', error);
      
      if (error.response) {
        throw new Error(error.response.data.message || 'Failed to generate customer PRD');
      } else if (error.request) {
        throw new Error('No response received from server');
      } else {
        throw new Error(error.message || 'Failed to generate customer PRD');
      }
    }
  },
  
  /**
   * Generate a developer-facing PRD for implementation
   * @param {string} projectId - The project ID
   * @returns {Promise<Object>} The generated PRD document
   */
  generateDeveloperPRD: async (projectId) => {
    try {
      console.log(`Generating developer-facing PRD for project ${projectId}`);
      const response = await api.post(`/api/prd/projects/${projectId}/developer-prd`);
      return response.data.data;
    } catch (error) {
      console.error('Error generating developer PRD:', error);
      
      if (error.response) {
        throw new Error(error.response.data.message || 'Failed to generate developer PRD');
      } else if (error.request) {
        throw new Error('No response received from server');
      } else {
        throw new Error(error.message || 'Failed to generate developer PRD');
      }
    }
  }
};

export default prdService;